"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AngularSyncStore_1 = __importStar(require("@CommonFrontend/Utils/AngularSyncStore"));
var NavigationSettingsHelper_1 = require("@CommonFrontendBackend/Project/NavigationSettingsHelper");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var GetBrandOrSnapshotColor_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBrandOrSnapshotColor");
var BrandStore_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandStore/BrandStore"));
var inversify_1 = require("inversify");
var mobx_1 = require("mobx");
var ProjectTypes_1 = require("Project/ProjectTypes");
var NavigationStore = (function (_super) {
    __extends(NavigationStore, _super);
    function NavigationStore(project, syncServices, brandStore) {
        var _this = _super.call(this, project, syncServices, {
            extractDataFromAngular: function (project) { return NavigationSettingsHelper_1.legacyNavigationSettingsSchemaWithoutDefaults.parse(project); },
            skipDiffOnAngularChange: true,
        }) || this;
        _this.brandStore = brandStore;
        _this.onAngularUpdated = function (newData) {
            _this.navigationSettings = NavigationSettingsHelper_1.NavigationSettingsHelper.fromLegacy(newData);
        };
        _this.onAngularUpdated(project);
        return _this;
    }
    Object.defineProperty(NavigationStore.prototype, "layout", {
        get: function () {
            return this.navigationSettings.layout;
        },
        set: function (layout) {
            this.navigationSettings.layout = layout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "items", {
        get: function () {
            return this.navigationSettings.items;
        },
        enumerable: false,
        configurable: true
    });
    NavigationStore.prototype.itemById = function (blockId) {
        return this.navigationSettings.items.find(function (item) { return item.blockId === blockId; });
    };
    Object.defineProperty(NavigationStore.prototype, "accept", {
        get: function () {
            if (!this.navigationSettings.accept) {
                return undefined;
            }
            if (!this.showAccept) {
                return undefined;
            }
            return __assign(__assign({}, this.navigationSettings.accept), { color: (0, GetBrandOrSnapshotColor_1.getBrandOrSnapshotColor)(this.navigationSettings.accept.color, this.brandStore.allColors), hasAgreement: this.navigationSettings.items.some(function (item) { return !!item.agreement; }) });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "showContactDetails", {
        get: function () {
            return this.navigationSettings.showContact;
        },
        set: function (showContactDetails) {
            this.navigationSettings.showContact = showContactDetails;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "springboardMenuEnabled", {
        get: function () {
            return this.navigationSettings.springboardMenuEnabled;
        },
        set: function (enable) {
            this.navigationSettings.springboardMenuEnabled = enable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "showDrawer", {
        get: function () {
            return this.navigationSettings.showDrawer;
        },
        set: function (showDrawer) {
            this.navigationSettings.showDrawer = showDrawer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "backgroundColor", {
        get: function () {
            return this.navigationSettings.backgroundColor;
        },
        set: function (color) {
            this.navigationSettings.backgroundColor = color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "themeAwareBackgroundColor", {
        get: function () {
            return (0, GetBrandOrSnapshotColor_1.getBrandOrSnapshotColor)(this.navigationSettings.backgroundColor, this.brandStore.allColors);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "showQuoteTotal", {
        get: function () {
            return this.navigationSettings.showQuoteTotal;
        },
        set: function (show) {
            this.navigationSettings.showQuoteTotal = show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "showAccept", {
        get: function () {
            return this.navigationSettings.cta.type === "accept";
        },
        set: function (enabled) {
            this.navigationSettings.cta.type = enabled ? "accept" : "none";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationStore.prototype, "dataForAngular", {
        get: function () {
            return NavigationSettingsHelper_1.NavigationSettingsHelper.toLegacy(this.navigationSettings);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_d = typeof NavigationSettingsHelper_1.NavigationSettings !== "undefined" && NavigationSettingsHelper_1.NavigationSettings) === "function" ? _d : Object)
    ], NavigationStore.prototype, "navigationSettings", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], NavigationStore.prototype, "layout", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NavigationStore.prototype, "items", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NavigationStore.prototype, "accept", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], NavigationStore.prototype, "showContactDetails", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], NavigationStore.prototype, "springboardMenuEnabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], NavigationStore.prototype, "showDrawer", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof commonTypes_1.IColorObjectType !== "undefined" && commonTypes_1.IColorObjectType) === "function" ? _e : Object),
        __metadata("design:paramtypes", [typeof (_f = typeof commonTypes_1.IColorObjectType !== "undefined" && commonTypes_1.IColorObjectType) === "function" ? _f : Object])
    ], NavigationStore.prototype, "backgroundColor", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], NavigationStore.prototype, "showAccept", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NavigationStore.prototype, "onAngularUpdated", void 0);
    NavigationStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("project")),
        __param(1, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __param(2, (0, inversify_1.inject)("brandStore")),
        __metadata("design:paramtypes", [typeof (_a = typeof ProjectTypes_1.IProject !== "undefined" && ProjectTypes_1.IProject) === "function" ? _a : Object, typeof (_b = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _b : Object, typeof (_c = typeof BrandStore_1.default !== "undefined" && BrandStore_1.default) === "function" ? _c : Object])
    ], NavigationStore);
    return NavigationStore;
}(AngularSyncStore_1.default));
exports.default = NavigationStore;
